import React, { useState, useEffect, Suspense } from "react";

import { getAPIData } from "../../services/api/axios";
import { API_PATHS } from "../../config";

import { Box } from "@mui/material";

import colorNegativeNumbers from "../../utils/dom/styling";

import JobTables from "../../features/analytics/dailyCost/JobTables";
import Visualizations from "../../features/analytics/dailyCost/visualizations";
import Title from "../../features/analytics/dailyCost/Title";
import Overview from "../../features/analytics/dailyCost/overview";
import LoadingPage from "../../components/LoadingPage";

/**
 * Entry point for the Daily Cost page app frontend.
 *
 * @component
 * @returns {JSX.Element} Daily cost analytics page.
 */
const DailyCost = () => {
  document.title = "R&S Daily Cost Page";
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const url = API_PATHS.COST.CURRENT_JOB_COST;
    getAPIData(url, setData).finally(() => {
      setIsLoading(false);
    });
  }, []);

  document.fonts.ready.then(() => {
    colorNegativeNumbers();
  });

  if (isLoading) {
    return <LoadingPage text={"R&S Daily Cost Page"} />;
  }

  return (
    data && (
      <div className="w-full bg-custom-rsbg">
        <div className="max-w-[1152px] min-w-[1152px] items-center mx-auto mb-20">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              pt: 4,
            }}
          >
            <Title
              data={data}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setData={setData}
              getData={getAPIData}
            />
            <Overview data={data} />
          </Box>
          <Visualizations data={data} />
          <Suspense fallback={<div>Loading...</div>}>
            <JobTables data={data} />
          </Suspense>
        </div>
      </div>
    )
  );
};

export default DailyCost;
